export interface IFrameStateModel {
  loaded: boolean;
}

export const IFRAME_INITIAL_STATE: IFrameStateModel = {
  loaded: false,
};
